import {fetchProjectDetail, fetchUpdateProjectContent} from '../../../contactLogic/manage/index';
import {mapState} from "vuex";
import event from '@/common/utils/event.js';

export default {
  name: 'createArt',
  data() {
    return {
      projectId: -1,
      tokenId: 0,
      projectName: '',
      projectArtist: '',
      projectDescription: '',
      projectWebsite: '',
      projectLicense: '',
      maxInvocations: '',
      mintPrice: '',
      detailData: {},
      projectBaseURI: '',
    };
  },
  computed: {
    ...mapState(['web3', 'ethersprovider', 'ethChainID', 'ethAddress']),
    isReady() {
      return this.web3 && this.ethersprovider && this.ethChainID && this.ethAddress;
    },
  },
  methods: {
    getParams() {
      return {
        web3: this.web3,
        library: this.ethersprovider,
        account: this.ethAddress,
        chainID: this.ethChainID,
        projectId: this.projectId,
      };
    },
    async getProjectDetail() {
      const params = this.getParams();
      const detailData = await fetchProjectDetail(params);
      const { projectName, artist, description, website, license, maxInvocations, projectBaseURI, pricePerTokenInWei } = detailData;
      this.projectName = projectName;
      this.projectArtist = artist;
      this.projectDescription = description;
      this.projectWebsite = website;
      this.projectLicense = license;
      this.maxInvocations = maxInvocations;
      this.projectBaseURI = projectBaseURI;
      this.mintPrice = pricePerTokenInWei;
    },
    async onProjectNameSave() {
      const comParams = this.getParams();
      const params = {
        ...comParams,
        type: 'projectName',
        content: this.projectName,
      };
      const result = await fetchUpdateProjectContent(params);
      event.$emit('sendtx', [
        result,
        {
          okinfo: `Success!`,
          failinfo: `Failed！`,
        },
      ]);

    },
    async onArtistSave() {
      const comParams = this.getParams();
      const params = {
        ...comParams,
        type: 'projectArtistName',
        content: this.projectArtist,
      };
      const result = await fetchUpdateProjectContent(params);
      event.$emit('sendtx', [
        result,
        {
          okinfo: `Success!`,
          failinfo: `Failed！`,
        },
      ]);
    },
    async onMintPriceSave() {
      const comParams = this.getParams();
      const params = {
        ...comParams,
        type: 'mintPrice',
        content: this.mintPrice,
      };
      const result = await fetchUpdateProjectContent(params);
      event.$emit('sendtx', [
        result,
        {
          okinfo: `Success!`,
          failinfo: `Failed！`,
        },
      ]);
    },
    async onDescriptionSave() {
      const comParams = this.getParams();
      const params = {
        ...comParams,
        type: 'projectDescription',
        content: this.projectDescription,
      };
      const result = await fetchUpdateProjectContent(params);
      event.$emit('sendtx', [
        result,
        {
          okinfo: `Success!`,
          failinfo: `Failed！`,
        },
      ]);
    },
    async onWebsiteSave() {
      const comParams = this.getParams();
      const params = {
        ...comParams,
        type: 'projectWebsite',
        content: this.projectWebsite,
      };
      const result = await fetchUpdateProjectContent(params);
      event.$emit('sendtx', [
        result,
        {
          okinfo: `Success!`,
          failinfo: `Failed！`,
        },
      ]);
    },
    async onLicenseSave() {
      const comParams = this.getParams();
      const params = {
        ...comParams,
        type: 'projectLicense',
        content: this.projectLicense,
      };
      const result = await fetchUpdateProjectContent(params);
      event.$emit('sendtx', [
        result,
        {
          okinfo: `Success!`,
          failinfo: `Failed！`,
        },
      ]);
    },
    async onMaxInvocationsSave() {
      const comParams = this.getParams();
      const params = {
        ...comParams,
        type: 'maxInvocations',
        content: this.maxInvocations,
      };
      const result = await fetchUpdateProjectContent(params);
      event.$emit('sendtx', [
        result,
        {
          okinfo: `Success!`,
          failinfo: `Failed！`,
        },
      ]);
    }
  },
  watch: {
    isReady(val) {
      if(val) {
        this.getProjectDetail();
      }
    }
  },
  created() {
    const { projectId, tokenId } = this.$route.params;
    this.projectId = projectId;
    this.tokenId = tokenId;
    if(this.isReady) {
      this.getProjectDetail();
    }
  }
};
